<template>
  <div class="component-upload-image">
    <div v-if="showExternalImgLink">
      <el-input  v-model="externalImageUrl" placeholder="请输入图片地址" @input="externalImageUrlChange"></el-input>

    </div>
    <el-upload
      multiple
      :action="uploadImgUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :on-progress="handleUploadProgress"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      ref="imageUpload"
      :on-remove="handleDelete"
      :show-file-list="true"
      :headers="headers"
      :data="uploadData"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="{hide: this.fileList.length >= this.limit}"
    >
      <i class="el-icon-plus">

      </i>
    </el-upload>

    <!-- 上传进度 -->
    <el-progress
      v-if="showProgress && uploadProgress > 0 && uploadProgress < 100"
      :percentage="uploadProgress"
      :stroke-width="6"
      style="margin-top: 10px;"
    ></el-progress>

    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      请上传
      <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
      <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
      的文件
      <template v-if="convertToWebP">
        <b style="color: #67c23a">（将自动转换为WebP格式 - {{ webpQuality }}质量）</b>
      </template>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      title="预览"
      width="800"
      append-to-body
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { listByIds, delOss } from "@/api/system/oss";
import { getMinioBucket } from "@/api/system/config";
import Cookies from "js-cookie";

export default {
  props: {
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 5,
    },
    // 大小限制(MB)
    fileSize: {
       type: Number,
      default: 5,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg","gif","bmp"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    returnValueField:{
      type: String,
      default: "ossId"
    },
    showExternalImgLink:{
      type: Boolean,
      default: false
    },
    // 是否转换为WebP
    convertToWebP: {
      type: Boolean,
      default: true
    },
    // WebP质量: high/medium/low/smallest/extreme
    webpQuality: {
      type: String,
      default: 'smallest',
      validator: (value) => ['high', 'medium', 'low', 'smallest', 'extreme'].includes(value)
    },
    // 存储桶名称（如果传入则使用传入值，否则从接口获取）
    bucket: {
      type: String,
      default: ''
    },
    // 是否显示上传进度
    showProgress: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      uploadProgress: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      uploadImgUrl: "https://test-minio.asdf.live/api/upload", // 新的上传接口地址
      headers: {
        Token: Cookies.get('token'),
        Authorization: "Bearer " + getToken(),
      },
      fileList: [],
      useExternalUrl: false,
      externalImageUrl: "",
      // 动态获取的 bucket 值
      currentBucket: ''
    };
  },
  mounted() {
    // 如果没有传入 bucket，则从接口获取
    if (!this.bucket) {
      this.fetchBucket();
    } else {
      this.currentBucket = this.bucket;
    }
  },
  computed: {
    // 上传时附加的数据
    uploadData() {
      const data = {};
      if (this.convertToWebP) {
        data.convertToWebP = 'true';
        data.webpQuality = this.webpQuality;
      }
      // 使用动态获取的 bucket 值
      if (this.currentBucket) {
        data.bucket = this.currentBucket;
      }
      return data;
    },
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  watch: {
    fileList:{
      handler(val){
        console.log("fileList",val)
        if(val && val.length>0 ){
          this.externalImageUrl=val[0].url
        }else{
          this.externalImageUrl="";
        }
      },
      deep:true,
      immediate:true
    },
    value: {
      async handler(val) {

        if (val) {
          // 首先将值转为数组
          let list;
          if (Array.isArray(val)) {
            list = val;
          } else {
            if(this.isNormalUrl(val)){
              //this.fileUrls=val;
              let urls= val.split(",");
              list=[];
              urls.forEach(x=>{
                 list.push({
                   ossId:x,
                   url:x
                 })
              })
              this.fileList=list;
              return list;
            }
            this.getRealUrl(val).then(a=>{
              list=a;
            })
          }
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            // 此处name使用ossId 防止删除出现重名
            item = { name: item.ossId, url: item.url, ossId: item.ossId };
            return item;
          });
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取 bucket 配置
    async fetchBucket() {
      try {
        const response = await getMinioBucket();
        if (response && response.data) {
          this.currentBucket = response.data;
        }
      } catch (error) {
        console.error('获取 bucket 配置失败:', error);
        // 如果获取失败，使用默认值
        this.currentBucket = 'kanbei';
      }
    },
    reset(){
     // debugger;
      this.fileList=[];
      this.externalImageUrl="";
      this.useExternalUrl=false;
      //this.showExternalImgLink=false;
    },
    externalImageUrlChange(val){
      if(val.trim()==""){
        return;
      }
      this.fileList=[{
        ossId:null,
        url:val
      }]
    },
    isNormalUrl(val){
      if(!val)return false;
      let ret= val.startsWith("http://") || val.startsWith("https://");
      return ret;
    },
    async getRealUrl(val){
      const {data}=await listByIds(val);
      return data;
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$modal.msgError(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
        return false;
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$modal.msgError(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      this.$modal.loading("正在上传图片，请稍候...");
      this.uploadProgress = 0;
      this.number++;
    },
    // 文件个数超出
    handleExceed() {
      this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传进度
    handleUploadProgress(event, file, fileList) {
      this.uploadProgress = Math.round((event.loaded / event.total) * 100);
    },
    // 上传成功回调（新接口格式）
    handleUploadSuccess(res, file) {
      if (res.success) {
        // 新接口返回的数据结构
        this.uploadList.push({
          name: res.data.originalName,
          url: res.data.url,
          ossId: res.data.etag,
          cdnUrl: res.data.cdnUrl
        });
        this.uploadedSuccessfully();
      } else {
        this.number--;
        this.$modal.closeLoading();
        this.$modal.msgError(res.error ? res.error.message : '上传失败');
        this.$refs.imageUpload.handleRemove(file);
        this.uploadedSuccessfully();
      }
      this.uploadProgress = 0;
    },
    // 删除图片
    handleDelete(file) {
      const findex = this.fileList.map(f => f.name).indexOf(file.name);
      if(findex > -1) {
        let ossId = this.fileList[findex].ossId;
        if(ossId && !this.isNormalUrl(ossId)) {
          delOss(ossId);
        }

        this.fileList.splice(findex, 1);
        //this.$emit("input", this.listToString(this.fileList));
        this.$emit("input", this.fileList);
      }
    },
    // 上传失败
    handleUploadError(res) {
      this.$modal.msgError("上传图片失败，请重试");
      this.$modal.closeLoading();
      this.uploadProgress = 0;
    },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        //this.$emit("input", this.listToString(this.fileList));
        this.$emit("input", this.fileList);
        this.$modal.closeLoading();
      }
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        if (list[i][this.returnValueField]) {
          strs += list[i][this.returnValueField] + separator;
        }
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    }
  }
};
</script>
<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
    display: none;
}
// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
    transition: all 0s;
}

::v-deep .el-list-enter, .el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}
</style>
